export default "__VITE_ASSET__3098b731__"